import styled from 'styled-components'

export type BackgroundForContentProps = {
  isMobile: boolean
  hasMediaMobile: boolean
}

const BackgroundText = styled.div<{ $isMobile: boolean; $hasMediaMobile: boolean }>`
  z-index: 8;
  aspect-ratio: 12 / 5;

  ${({ $isMobile, $hasMediaMobile }) =>
    `
    ${$isMobile && 'bottom: 0'};
    width: ${$isMobile ? '100vw' : '71.74vw'};
    height: ${$isMobile ? '30vh' : '100%'};
    background: ${
      $isMobile
        ? $hasMediaMobile
          ? 'linear-gradient(0deg, #000 0%, rgba(0, 0, 0, 0.00) 100%)'
          : 'transparent'
        : 'linear-gradient(90deg,rgba(14, 16, 19, 0.8) 2.42%,rgba(0, 0, 0, 0) 100%,rgba(14, 16, 18, 0) 100%)'
    };
  `}
`
const BackgroundForContent = ({ isMobile, hasMediaMobile }: BackgroundForContentProps) => {
  return (
    <BackgroundText
      $isMobile={isMobile}
      $hasMediaMobile={hasMediaMobile}
      className='_position-absolute'
      data-test='background-text'
    />
  )
}

export default BackgroundForContent
